module.exports = __webpack_public_path__ + "fonts/Loewe.752d541.woff";